import { SelectContainer, SelectElement } from "./SelectStyles";

function Select(props) {
  return (
    <SelectContainer {...props}>
      <SelectElement {...props} />
    </SelectContainer>
  );
}

export default Select;
